(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Administrativogeneral', Administrativogeneral);

    Administrativogeneral.$inject = ['$resource'];

    function Administrativogeneral ($resource) {
        var resourceUrl =  'apo/extracciondatos:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
